// extracted by mini-css-extract-plugin
module.exports = {"appDownloadIcons":"_1cOhUpm4y6ep2xFT-rdMEh","svg":"_2iLZtIa1tEq4FRL-gSZ47u","appDownloadIcons--onWhite":"UrgGhNwxuOEcC0vOQMYpm"};